import GameIds from 'a/hub/data/GameIds';
import {
  DESTINATION_GROUP,
  NAVIGATION_ORIGIN,
  NAVIGATION_TRIGGER_TYPE,
} from 'root/lib/SearchlightDispatcher';
import { reportNavigation } from 'a/hub/actions/metagameSearchlight';
import { PRODUCT_LECTURA } from 'root/lib/constants';

import { ACTIONS, PLACEMENT_TOOL, PLACEMENT_TOOL_ES } from '../../data/constants';
import { calculateScore } from '../../api/scoring';
import { reportMeasureComplete } from '../../api/reportingEvents';
import { getCurrentInterstitial } from '../selectors';

export const setMeasuresForGrade = payload => ({
  gameId: GameIds.PLACEMENT_TOOL,
  type: ACTIONS.SET_MEASURES_FOR_GRADE,
  payload,
});

export const beginNextMeasure = () => ({
  gameId: GameIds.PLACEMENT_TOOL,
  type: ACTIONS.BEGIN_NEXT_MEASURE,
  payload: {},
});

export const completeCurrentMeasure = (measureId, timing, results, scoring, hasTroError, product) =>
  (dispatch, getState) => {
    const score = calculateScore(results.total_score, scoring);
    reportMeasureComplete(measureId, timing, { ...results, score }, dispatch);
    dispatch({
      gameId: product === PRODUCT_LECTURA ? PLACEMENT_TOOL_ES : PLACEMENT_TOOL,
      type: ACTIONS.COMPLETE_CURRENT_MEASURE,
      payload: { ...results, score, hasTroError },
    });

    const navigationParams = {
      destination: `INTERSTITIAL_${getCurrentInterstitial(getState())}`,
      destinationGroup: DESTINATION_GROUP.PLACEMENT_TOOL,
      origin: NAVIGATION_ORIGIN.MEASURE,
      trigger: 'goToInterstitial',
      triggerType: NAVIGATION_TRIGGER_TYPE.AUTOMATIC,
    };
    dispatch(reportNavigation({ ...navigationParams }));
  };

export const updateIPTMetrics = () => ({
  gameId: GameIds.PLACEMENT_TOOL,
  type: ACTIONS.UPDATE_IPT_METRICS,
  payload: {},
});

export const updateIPTCompleteTime = currentProduct => ({
  gameId: GameIds.PLACEMENT_TOOL,
  type: ACTIONS.UPDATE_COMPLETE_IPT_METRICS,
  payload: currentProduct,
});

export const setRoundSessionId = (gameId, measureId, roundSessionId) => ({
  gameId,
  type: ACTIONS.SET_ROUND_SESSION_ID,
  payload: { [measureId]: roundSessionId },
});

export const setTroRequest = (gameId, payload) => ({
  gameId,
  type: ACTIONS.SET_TRO_REQUEST,
  payload,
});

export const setIsValidTroResult = (gameId, payload) => ({
  gameId,
  type: ACTIONS.SET_IS_VALID_TRO_RESULT,
  payload,
});

export const resetBenchmarkEOY = () => ({
  gameId: GameIds.TRO_BENCHMARK,
  type: ACTIONS.RESET_BENCHMARK_EOY,
});

export const resetBenchmarkModeRedirectFlag = payload => ({
  gameId: GameIds.TRO_BENCHMARK,
  type: ACTIONS.RESET_BENCHMARK_MODE_REDIRECT_FLAG,
  payload,
});

export const setShouldDisplayAmpGlobalNav = (gameId, payload) => ({
  gameId,
  type: ACTIONS.SET_SHOULD_DISPLAY_AMP_GLOBAL_NAV,
  payload,
});

export const setRWRComplete = (payload = null) => ({
  gameId: GameIds.TRO_BENCHMARK,
  type: ACTIONS.SET_RWR_COMPLETE,
  payload,
});

export const setTroError = (gameId, payload) => ({
  gameId,
  type: ACTIONS.SET_TRO_ERROR,
  payload,
});
